// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardCurrentOpsController = function ($scope, $rootScope, $location, $routeParams, $http, $interval, CurrentOp) {
    const load = function () {
        $scope.currentOps = CurrentOp.query();
    }

    $scope.$on('refresh', function (event) {
        load();
    });

    $scope.getCommandName = function (op) {
        return Object.keys(extractCommandBody(op))[0];
    };

    const extractCommandBody = function (op) {
        if (op.op === "getmore") {
            return op.cursor.originatingCommand;
        }
        return op.command;
    }

    $scope.getCommandBody = function (op) {
        let body = extractCommandBody(op);
        body = structuredClone(body);
        body.lsid = undefined;
        body.$clusterTime = undefined;
        return body;
    };

    // can't use angular.js's `| json` filter, since it strips properties starting with `$`
    $scope.formatJson = function (obj) {
        return JSON.stringify(obj, null, 2);
    }

    $scope.showRaw = function (op) {
        $scope.raw = op;
    }

    load();
};
DashboardCurrentOpsController.$inject = ['$scope', '$rootScope', '$location', '$routeParams', '$http', '$interval', 'CurrentOp'];
